import React from "react";
import ProfilesAndSettings from "views/Config/Profiles/Common";
import { composedAPI } from "./api";
import throughputComposition from "./composition";
import help from "help/viewThroughputProfileConfig.md";
import settingsHelp from "help/viewThroughputProfileConfigSettings.md";

const ConfigThroughputProfiles = ({ ...settings }) => (
  <ProfilesAndSettings
    {...throughputComposition}
    {...composedAPI}
    {...settings}
    help={help}
    settingsHelp={settingsHelp}
  />
);

export default ConfigThroughputProfiles;
